module.exports = __webpack_public_path__ + "img/401.de2c23d9.svg";